/* Useful utility functions to be called  */

export const capsFirstLetter = (stringBlock) => {  //Caps first letter of input string and return it
    return `${stringBlock.charAt(0).toUpperCase() + stringBlock.slice(1)}`;
}
